
import { IEntityMapping } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MappingPropertyInput from '@/components/Importer/MappingPropertyInput.vue';
import IPassengerPhonNumberViewModel from '@/components/Passenger/models/IPassengerPhoneNumberViewModel';

@Component({
  components: {
    MappingPropertyInput,
  },
})
export default class PhoneNumberMapper extends Vue {
  mapping: IEntityMapping<IPassengerPhonNumberViewModel> | null = null;

  @Prop({ required: true }) index: number;
  @Prop({ required: true }) value: IEntityMapping<IPassengerPhonNumberViewModel>;

  @Watch('value', { immediate: true }) onValueChanged() {
    this.mapping = this.value;
  }

  @Watch('mapping', { deep: true, immediate: true }) onMappingChanged() {
    this.$emit('input', this.mapping);
  }

  removeMapping() {
    this.$emit('delete');
  }

}
